module.exports = __webpack_public_path__ + "static/img/1.544fe82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/1.jpg
// module id = RFg0
// module chunks = 1